<div class="modal-header">
    <h5 class="modal-title">{{ noticeTemplate.id ? 'Chỉnh sửa' : 'Thêm' }} Mẫu Thông Báo</h5>
    <button type="button" class="close" aria-label="Đóng" (click)="onCancelClick()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <form>
      <div class="form-group">
        <label for="title">Tiêu Đề</label>
        <input type="text" class="form-control" id="title" [(ngModel)]="noticeTemplate.title" name="title">
      </div>
      <div class="form-group">
        <label for="contentTemplate">Mẫu Nội Dung</label>
        <textarea class="form-control" id="contentTemplate" [(ngModel)]="noticeTemplate.contentTemplate" name="contentTemplate" rows="5"></textarea>
      </div>
    </form>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-outline-secondary" (click)="onCancelClick()">Hủy</button>
    <button type="button" class="btn btn-outline-primary" (click)="saveNoticeTemplate()">Lưu</button>
  </div>

